/**
 * Filters out null and undefined values from an array.
 *
 * @template T
 * @param {(Array<T | null | undefined> | null | undefined)} maybeArray
 * @returns {T[]}
 */
export function list(maybeArray) {
  return (
    maybeArray?.filter(/** @type {(x: T | null | undefined) => x is T} */ (x) => x != null) ?? []
  );
}
